const countryOptions = [
    { countryID: 1, countryName: 'United Arab Emirates', ios2: 'AE' },
    { countryID: 2, countryName: 'Afghanistan', ios2: 'AF' },
    { countryID: 3, countryName: 'Antigua and Barbuda', ios2: 'AG' },
    { countryID: 4, countryName: 'Anguilla', ios2: 'AI' },
    { countryID: 5, countryName: 'Albania', ios2: 'AL' },
    { countryID: 6, countryName: 'Armenia', ios2: 'AM' },
    { countryID: 7, countryName: 'Netherlands Antilles', ios2: 'AN' },
    { countryID: 8, countryName: 'Angola', ios2: 'AO' },
    { countryID: 9, countryName: 'Antarctica', ios2: 'AQ' },
    { countryID: 10, countryName: 'Argentina', ios2: 'AR' },
    { countryID: 11, countryName: 'American Samoa', ios2: 'AS' },
    { countryID: 12, countryName: 'Austria', ios2: 'AT' },
    { countryID: 13, countryName: 'Australia', ios2: 'AU' },
    { countryID: 14, countryName: 'Aruba', ios2: 'AW' },
    { countryID: 15, countryName: 'Azerbaijan', ios2: 'AZ' },
    { countryID: 16, countryName: 'Bosnia and Herzegovina', ios2: 'BA' },
    { countryID: 17, countryName: 'Barbados', ios2: 'BB' },
    { countryID: 18, countryName: 'Bangladesh', ios2: 'BD' },
    { countryID: 19, countryName: 'Belgium', ios2: 'BE' },
    { countryID: 20, countryName: 'Burkina Faso', ios2: 'BF' },
    { countryID: 21, countryName: 'Bulgaria', ios2: 'BG' },
    { countryID: 22, countryName: 'Bahrain', ios2: 'BH' },
    { countryID: 23, countryName: 'Burundi', ios2: 'BI' },
    { countryID: 24, countryName: 'Benin', ios2: 'BJ' },
    { countryID: 25, countryName: 'Bermuda', ios2: 'BM' },
    { countryID: 26, countryName: 'Brunei Darussalam', ios2: 'BN' },
    { countryID: 27, countryName: 'Bolivia', ios2: 'BO' },
    { countryID: 28, countryName: 'Brazil', ios2: 'BR' },
    { countryID: 29, countryName: 'The Bahamas', ios2: 'BS' },
    { countryID: 30, countryName: 'Bhutan', ios2: 'BT' },
    { countryID: 31, countryName: 'Bouvet Island', ios2: 'BV' },
    { countryID: 32, countryName: 'Botswana', ios2: 'BW' },
    { countryID: 33, countryName: 'Belarus', ios2: 'BY' },
    { countryID: 34, countryName: 'Belize', ios2: 'BZ' },
    { countryID: 35, countryName: 'Canada', ios2: 'CA' },
    { countryID: 36, countryName: 'Cocos (Keeling) Islands', ios2: 'CC' },
    { countryID: 37, countryName: 'Congo, Democratic Republic of the', ios2: 'CD' },
    { countryID: 38, countryName: 'Central African Republic', ios2: 'CF' },
    { countryID: 39, countryName: 'Congo, Republic of the', ios2: 'CG' },
    { countryID: 40, countryName: 'Switzerland', ios2: 'CH' },
    { countryID: 41, countryName: "Cote d'Ivoire", ios2: 'CI' },
    { countryID: 42, countryName: 'Cook Islands', ios2: 'CK' },
    { countryID: 43, countryName: 'Chile', ios2: 'CL' },
    { countryID: 44, countryName: 'Cameroon', ios2: 'CM' },
    { countryID: 45, countryName: 'China', ios2: 'CN' },
    { countryID: 46, countryName: 'Colombia', ios2: 'CO' },
    { countryID: 47, countryName: 'Costa Rica', ios2: 'CR' },
    { countryID: 48, countryName: 'Cuba', ios2: 'CU' },
    { countryID: 49, countryName: 'Cape Verde', ios2: 'CV' },
    { countryID: 50, countryName: 'Christmas Island', ios2: 'CX' },
    { countryID: 51, countryName: 'Cyprus', ios2: 'CY' },
    { countryID: 52, countryName: 'Czech Republic', ios2: 'CZ' },
    { countryID: 53, countryName: 'Germany', ios2: 'DE' },
    { countryID: 54, countryName: 'Djibouti', ios2: 'DJ' },
    { countryID: 55, countryName: 'Denmark', ios2: 'DK' },
    { countryID: 56, countryName: 'Dominica', ios2: 'DM' },
    { countryID: 57, countryName: 'Dominican Republic', ios2: 'DO' },
    { countryID: 58, countryName: 'Algeria', ios2: 'DZ' },
    { countryID: 59, countryName: 'Ecuador', ios2: 'EC' },
    { countryID: 60, countryName: 'Estonia', ios2: 'EE' },
    { countryID: 61, countryName: 'Egypt', ios2: 'EG' },
    { countryID: 62, countryName: 'Western Sahara', ios2: 'EH' },
    { countryID: 63, countryName: 'Eritrea', ios2: 'ER' },
    { countryID: 64, countryName: 'Spain', ios2: 'ES' },
    { countryID: 65, countryName: 'Ethiopia', ios2: 'ET' },
    { countryID: 66, countryName: 'Finland', ios2: 'FI' },
    { countryID: 67, countryName: 'Fiji', ios2: 'FJ' },
    { countryID: 68, countryName: 'Falkland Islands (Islas Malvinas)', ios2: 'FK' },
    { countryID: 69, countryName: 'Micronesia, Federated States of', ios2: 'FM' },
    { countryID: 70, countryName: 'Faroe Islands', ios2: 'FO' },
    { countryID: 71, countryName: 'France', ios2: 'FR' },
    { countryID: 72, countryName: 'France, Metropolitan', ios2: '--' },
    { countryID: 73, countryName: 'Gabon', ios2: 'GA' },
    { countryID: 74, countryName: 'Grenada', ios2: 'GD' },
    { countryID: 75, countryName: 'Georgia', ios2: 'GE' },
    { countryID: 76, countryName: 'French Guiana', ios2: 'GF' },
    { countryID: 77, countryName: 'Guernsey', ios2: '--' },
    { countryID: 78, countryName: 'Ghana', ios2: 'GH' },
    { countryID: 79, countryName: 'Gibraltar', ios2: 'GI' },
    { countryID: 80, countryName: 'Greenland', ios2: 'GL' },
    { countryID: 81, countryName: 'The Gambia', ios2: 'GM' },
    { countryID: 82, countryName: 'Guinea', ios2: 'GN' },
    { countryID: 83, countryName: 'Guadeloupe', ios2: 'GP' },
    { countryID: 84, countryName: 'Equatorial Guinea', ios2: 'GQ' },
    { countryID: 85, countryName: 'Greece', ios2: 'GR' },
    { countryID: 86, countryName: 'South Georgia and the South Sandwich Islands', ios2: 'GS' },
    { countryID: 87, countryName: 'Guatemala', ios2: 'GT' },
    { countryID: 88, countryName: 'Guam', ios2: 'GU' },
    { countryID: 89, countryName: 'Guinea-Bissau', ios2: 'GW' },
    { countryID: 90, countryName: 'Guyana', ios2: 'GY' },
    { countryID: 91, countryName: 'Hong Kong', ios2: 'HK' },
    { countryID: 92, countryName: 'Heard Island and McDonald Islands', ios2: 'HM' },
    { countryID: 93, countryName: 'Honduras', ios2: 'HN' },
    { countryID: 94, countryName: 'Croatia', ios2: 'HR' },
    { countryID: 95, countryName: 'Haiti', ios2: 'HT' },
    { countryID: 96, countryName: 'Hungary', ios2: 'HU' },
    { countryID: 97, countryName: 'Indonesia', ios2: 'ID' },
    { countryID: 98, countryName: 'Ireland', ios2: 'IE' },
    { countryID: 99, countryName: 'Israel', ios2: 'IL' },
    { countryID: 100, countryName: 'Man, Isle of', ios2: '--' },
    { countryID: 101, countryName: 'India', ios2: 'IN' },
    { countryID: 102, countryName: 'British Indian Ocean Territory', ios2: 'IO' },
    { countryID: 103, countryName: 'Iraq', ios2: 'IQ' },
    { countryID: 104, countryName: 'Iran', ios2: 'IR' },
    { countryID: 105, countryName: 'Iceland', ios2: 'IS' },
    { countryID: 106, countryName: 'Italy', ios2: 'IT' },
    { countryID: 107, countryName: 'Jersey', ios2: '--' },
    { countryID: 108, countryName: 'Jamaica', ios2: 'JM' },
    { countryID: 109, countryName: 'Jordan', ios2: 'JO' },
    { countryID: 110, countryName: 'Japan', ios2: 'JP' },
    { countryID: 111, countryName: 'Kenya', ios2: 'KE' },
    { countryID: 112, countryName: 'Kyrgyzstan', ios2: 'KG' },
    { countryID: 113, countryName: 'Cambodia', ios2: 'KH' },
    { countryID: 114, countryName: 'Kiribati', ios2: 'KI' },
    { countryID: 115, countryName: 'Comoros', ios2: 'KM' },
    { countryID: 116, countryName: 'Saint Kitts and Nevis', ios2: 'KN' },
    { countryID: 117, countryName: 'Korea, North', ios2: 'KP' },
    { countryID: 118, countryName: 'Korea, Republic of', ios2: 'KR' },
    { countryID: 119, countryName: 'Kuwait', ios2: 'KW' },
    { countryID: 120, countryName: 'Cayman Islands', ios2: 'KY' },
    { countryID: 121, countryName: 'Kazakhstan', ios2: 'KZ' },
    { countryID: 122, countryName: 'Laos', ios2: 'LA' },
    { countryID: 123, countryName: 'Lebanon', ios2: 'LB' },
    { countryID: 124, countryName: 'Saint Lucia', ios2: 'LC' },
    { countryID: 125, countryName: 'Liechtenstein', ios2: 'LI' },
    { countryID: 126, countryName: 'Sri Lanka', ios2: 'LK' },
    { countryID: 127, countryName: 'Liberia', ios2: 'LR' },
    { countryID: 128, countryName: 'Lesotho', ios2: 'LS' },
    { countryID: 129, countryName: 'Lithuania', ios2: 'LT' },
    { countryID: 130, countryName: 'Luxembourg', ios2: 'LU' },
    { countryID: 131, countryName: 'Latvia', ios2: 'LV' },
    { countryID: 132, countryName: 'Libya', ios2: 'LY' },
    { countryID: 133, countryName: 'Morocco', ios2: 'MA' },
    { countryID: 134, countryName: 'Monaco', ios2: 'MC' },
    { countryID: 135, countryName: 'Moldova', ios2: 'MD' },
    { countryID: 136, countryName: 'Madagascar', ios2: 'MG' },
    { countryID: 137, countryName: 'Marshall Islands', ios2: 'MH' },
    { countryID: 138, countryName: 'Macedonia, The Former Yugoslav Republic of', ios2: 'MK' },
    { countryID: 139, countryName: 'Mali', ios2: 'ML' },
    { countryID: 140, countryName: 'Myanmar', ios2: 'MM' },
    { countryID: 141, countryName: 'Mongolia', ios2: 'MN' },
    { countryID: 142, countryName: 'Macau', ios2: 'MO' },
    { countryID: 143, countryName: 'Northern Mariana Islands', ios2: 'MP' },
    { countryID: 144, countryName: 'Martinique', ios2: 'MQ' },
    { countryID: 145, countryName: 'Mauritania', ios2: 'MR' },
    { countryID: 146, countryName: 'Montserrat', ios2: 'MS' },
    { countryID: 147, countryName: 'Malta', ios2: 'MT' },
    { countryID: 148, countryName: 'Mauritius', ios2: 'MU' },
    { countryID: 149, countryName: 'Maldives', ios2: 'MV' },
    { countryID: 150, countryName: 'Malawi', ios2: 'MW' },
    { countryID: 151, countryName: 'Mexico', ios2: 'MX' },
    { countryID: 152, countryName: 'Malaysia', ios2: 'MY' },
    { countryID: 153, countryName: 'Mozambique', ios2: 'MZ' },
    { countryID: 154, countryName: 'Namibia', ios2: 'NA' },
    { countryID: 155, countryName: 'New Caledonia', ios2: 'NC' },
    { countryID: 156, countryName: 'Niger', ios2: 'NE' },
    { countryID: 157, countryName: 'Norfolk Island', ios2: 'NF' },
    { countryID: 158, countryName: 'Nigeria', ios2: 'NG' },
    { countryID: 159, countryName: 'Nicaragua', ios2: 'NI' },
    { countryID: 160, countryName: 'Netherlands', ios2: 'NL' },
    { countryID: 161, countryName: 'Norway', ios2: 'NO' },
    { countryID: 162, countryName: 'Nepal', ios2: 'NP' },
    { countryID: 163, countryName: 'Nauru', ios2: 'NR' },
    { countryID: 164, countryName: 'Niue', ios2: 'NU' },
    { countryID: 165, countryName: 'New Zealand', ios2: 'NZ' },
    { countryID: 166, countryName: 'Oman', ios2: 'OM' },
    { countryID: 167, countryName: 'Panama', ios2: 'PA' },
    { countryID: 168, countryName: 'Peru', ios2: 'PE' },
    { countryID: 169, countryName: 'French Polynesia', ios2: 'PF' },
    { countryID: 170, countryName: 'Papua New Guinea', ios2: 'PG' },
    { countryID: 171, countryName: 'Philippines', ios2: 'PH' },
    { countryID: 172, countryName: 'Pakistan', ios2: 'PK' },
    { countryID: 173, countryName: 'Poland', ios2: 'PL' },
    { countryID: 174, countryName: 'Saint Pierre and Miquelon', ios2: 'PM' },
    { countryID: 175, countryName: 'Pitcairn Islands', ios2: 'PN' },
    { countryID: 176, countryName: 'Puerto Rico', ios2: 'PR' },
    { countryID: 177, countryName: 'Palestinian Territory, Occupied', ios2: 'PS' },
    { countryID: 178, countryName: 'Portugal', ios2: 'PT' },
    { countryID: 179, countryName: 'Palau', ios2: 'PW' },
    { countryID: 180, countryName: 'Paraguay', ios2: 'PY' },
    { countryID: 181, countryName: 'Qatar', ios2: 'QA' },
    { countryID: 182, countryName: 'Reunion', ios2: 'RE' },
    { countryID: 183, countryName: 'Romania', ios2: 'RO' },
    { countryID: 184, countryName: 'Russian Federation', ios2: 'RU' },
    { countryID: 185, countryName: 'Rwanda', ios2: 'RW' },
    { countryID: 186, countryName: 'Saudi Arabia', ios2: 'SA' },
    { countryID: 187, countryName: 'Solomon Islands', ios2: 'SB' },
    { countryID: 188, countryName: 'Seychelles', ios2: 'SC' },
    { countryID: 189, countryName: 'Sudan', ios2: 'SD' },
    { countryID: 190, countryName: 'Sweden', ios2: 'SE' },
    { countryID: 191, countryName: 'Singapore', ios2: 'SG' },
    { countryID: 192, countryName: 'Saint Helena', ios2: 'SH' },
    { countryID: 193, countryName: 'Slovenia', ios2: 'SI' },
    { countryID: 194, countryName: 'Svalbard', ios2: 'SJ' },
    { countryID: 195, countryName: 'Slovakia', ios2: 'SK' },
    { countryID: 196, countryName: 'Sierra Leone', ios2: 'SL' },
    { countryID: 197, countryName: 'San Marino', ios2: 'SM' },
    { countryID: 198, countryName: 'Senegal', ios2: 'SN' },
    { countryID: 199, countryName: 'Somalia', ios2: 'SO' },
    { countryID: 200, countryName: 'Suriname', ios2: 'SR' },
    { countryID: 201, countryName: 'S?Tom?nd Pr?ipe', ios2: 'ST' },
    { countryID: 202, countryName: 'El Salvador', ios2: 'SV' },
    { countryID: 203, countryName: 'Syria', ios2: 'SY' },
    { countryID: 204, countryName: 'Swaziland', ios2: 'SZ' },
    { countryID: 205, countryName: 'Turks and Caicos Islands', ios2: 'TC' },
    { countryID: 206, countryName: 'Chad', ios2: 'TD' },
    { countryID: 207, countryName: 'French Southern and Antarctic Lands', ios2: 'TF' },
    { countryID: 208, countryName: 'Togo', ios2: 'TG' },
    { countryID: 209, countryName: 'Thailand', ios2: 'TH' },
    { countryID: 210, countryName: 'Tajikistan', ios2: 'TJ' },
    { countryID: 211, countryName: 'Tokelau', ios2: 'TK' },
    { countryID: 212, countryName: 'Turkmenistan', ios2: 'TM' },
    { countryID: 213, countryName: 'Tunisia', ios2: 'TN' },
    { countryID: 214, countryName: 'Tonga', ios2: 'TO' },
    { countryID: 215, countryName: 'East Timor', ios2: 'TL' },
    { countryID: 216, countryName: 'Turkey', ios2: 'TR' },
    { countryID: 217, countryName: 'Trinidad and Tobago', ios2: 'TT' },
    { countryID: 218, countryName: 'Tuvalu', ios2: 'TV' },
    { countryID: 219, countryName: 'Taiwan', ios2: 'TW' },
    { countryID: 220, countryName: 'Tanzania', ios2: 'TZ' },
    { countryID: 221, countryName: 'Ukraine', ios2: 'UA' },
    { countryID: 222, countryName: 'Uganda', ios2: 'UG' },
    { countryID: 223, countryName: 'United Kingdom', ios2: 'GB' },
    { countryID: 224, countryName: 'United States Minor Outlying Islands', ios2: 'UM' },
    { countryID: 225, countryName: 'United States', ios2: 'US' },
    { countryID: 226, countryName: 'Uruguay', ios2: 'UY' },
    { countryID: 227, countryName: 'Uzbekistan', ios2: 'UZ' },
    { countryID: 228, countryName: 'Holy See (Vatican City)', ios2: 'VA' },
    { countryID: 229, countryName: 'Saint Vincent and the Grenadines', ios2: 'VC' },
    { countryID: 230, countryName: 'Venezuela', ios2: 'VE' },
    { countryID: 231, countryName: 'British Virgin Islands', ios2: 'VG' },
    { countryID: 232, countryName: 'Virgin Islands', ios2: 'VI' },
    { countryID: 233, countryName: 'Vietnam', ios2: 'VN' },
    { countryID: 234, countryName: 'Vanuatu', ios2: 'VU' },
    { countryID: 235, countryName: 'Wallis and Futuna', ios2: 'WF' },
    { countryID: 236, countryName: 'Samoa', ios2: 'WS' },
    { countryID: 237, countryName: 'Yemen', ios2: 'YE' },
    { countryID: 238, countryName: 'Mayotte', ios2: 'YT' },
    { countryID: 239, countryName: 'Yugoslavia', ios2: 'YU' },
    { countryID: 240, countryName: 'South Africa', ios2: 'ZA' },
    { countryID: 241, countryName: 'Zambia', ios2: 'ZM' },
    { countryID: 242, countryName: 'Zimbabwe', ios2: 'ZW' },
    { countryID: 1002, countryName: 'Bulgaria', ios2: 'BG' },
    { countryID: 1003, countryName: 'Montenegro', ios2: 'ME' },
    { countryID: 1004, countryName: 'Serbia', ios2: 'RS' },
    { countryID: 1005, countryName: 'South Sudan', ios2: 'SS' },
    { countryID: 1006, countryName: 'Zaire', ios2: 'ZR' },
    { countryID: 1007, countryName: 'NETHERLANDS', ios2: 'A' },
    { countryID: 1008, countryName: 'Andorra', ios2: 'AD' }
]
export default countryOptions
